var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "loading-mini-container d-flex justify-content-center align-items-center",
      class: { show: _vm.visible },
    },
    [_c("UiSpinner")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }